<template>
  <v-container
    fluid
    style="height: 100%;"
    class="pa-4"
  >
    <v-row
      class="mb-6"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
      >
        <base-material-card
          icon="mdi-account-circle-outline"
          class="pa-3 text-start"
          color="secondary"
          :loading="loading"
        >
          <v-row>
            <v-col
              cols="12"
              md="8"
            >
              <v-autocomplete
                ref="customerAutocomplete"
                v-model="selectedCustomer"
                :items="allCustomers"
                outlined
                dense
                label="Selecione o cliente:"
                placeholder="Digite o código ou a descrição do cliente"
                prepend-inner-icon="mdi-magnify"
                return-object
                item-text="text"
                item-value="value"
                autofocus
                autocomplete="off"
                no-data-text="Nenhum cliente encontrado."
                @change="onSelectCustomer"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="d-flex align-start"
            >
              <v-btn
                class="rounded-pill"
                medium
                dark
                color="primary"
                @click="eraseSearch()"
              >
                <v-icon icon="mdi-delete" />
                Nova Busca
              </v-btn>
              <v-btn
                class="rounded-pill ms-2"
                medium
                dark
                color="primary"
                @click="openCustomerForm()"
              >
                <v-icon left>
                  mdi-cog-outline
                </v-icon>
                Configurações
              </v-btn>
            </v-col>
          </v-row>
          <v-sheet
            v-if="selectedCustomer"
          >
            <v-tabs
              v-model="tab"
              grow
            >
              <v-tab style="width: 13.8%;">
                <v-icon class="me-1">
                  mdi-invoice-text-fast-outline
                </v-icon>
                Dados Cadastrais
              </v-tab>
              <v-tab>
                <v-icon class="me-1">
                  mdi-text-box-outline
                </v-icon>
                Observações
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <registration-data :customer="selectedCustomer" />
              </v-tab-item>
              <v-tab-item>
                <observations :customer="selectedCustomer" />
              </v-tab-item>
            </v-tabs-items>

            <form-customer
              ref="customerForm"
              @update="updateCustomers()"
            />
          </v-sheet>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import RegistrationData from './components/risc-clientes/RegistrationData.vue'
  import Observations from './components/risc-clientes/Observations.vue'
  import FormCustomer from './components/form/CustomerForm'

  export default {
    name: 'ListClinicCustomers',
    components: {
      RegistrationData,
      Observations,
      FormCustomer,
    },
    data () {
      return {
        selectedCustomer: null,
        allCustomers: [],
        isOpenCustomerSearch: false,
        loading: false,
        tab: null,
        customerFormDialog: false,
      }
    },
    created () {
      this.fetchCustomers()
      this.watchRouteQuery()
    },
    methods: {
      ...mapActions('customers', ['listRiscSqlCustomers', 'getCustomerByCode']),

      async fetchCustomers () {
        this.loading = true
        try {
          const response = await this.listRiscSqlCustomers()
          if (response && response.results) {
            this.allCustomers = response.results.map(c => ({
              ...c,
              text: `${c.tbCodigo} - ${c.tbDescricao}` + (c.tbRazaoSocial && c.tbRazaoSocial !== c.tbDescricao ? ` - ${c.tbRazaoSocial}` : ''),
              value: c.tbCodigo,
            }))
          }
        } catch (error) {
          console.error('Erro ao buscar clientes:', error)
        }
        this.loading = false
      },

      onSelectCustomer () {
        if (this.selectedCustomer) {
          this.$emit('customer-selected', this.selectedCustomer.tbCodigo)
        }
      },

      eraseSearch () {
        this.selectedCustomer = null
        setTimeout(() => {
          this.$refs.customerAutocomplete.focus()
        }, 50)
      },

      async openCustomerForm (clone = false) {
        if (!this.selectedCustomer || !this.selectedCustomer.tbCodigo) {
          console.error('Nenhum cliente selecionado')
          return
        }

        try {
          // const customer = await this.getCustomerByCode(this.selectedCustomer.tbCodigo)
          // if (customer && customer._id) {
          this.$refs.customerForm.openForm({ customerCode: this.selectedCustomer.tbCodigo }, clone)
          // } else {
          // this.$alert('error', 'ID do cliente não encontrado para abrir o formulário.')
          // }
        } catch (err) {
          console.error('Erro ao buscar cliente pelo código:', err)
        }
      },

      watchRouteQuery () {
        this.$watch('$route.query.customer', (newVal, oldVal) => {
          if (newVal !== oldVal && this.allCustomers.length) {
            const customerFound = this.allCustomers.find(c => c.tbCodigo === newVal)
            if (customerFound) {
              this.selectedCustomer = customerFound
            }
          }
        })
      },
    },
  }
</script>

<style scoped>

.v-btn.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}

</style>
